import { AppState } from 'src/ducks';

export const __REDUX_STATE_KEY__ = 'router';

export const getReduxStateSlice = (state: AppState) => state[__REDUX_STATE_KEY__];

export const getPage = (state: AppState) => getReduxStateSlice(state).page;
